/**
 * Created by hernanherreros on 2019-07-05
 */

import * as React from 'react'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import Content from '../../components/Layout/Content'
import { mobileStoreLinks } from '../../config/sharing.config'
import styled from 'styled-components'
import animation from '../../static/animations/not-found.json'
import { Trans } from '@lingui/macro'
import LottieAnimation from '../../components/Utils/LottieAnimation'
import loadingAnimation from '../../static/animations/loading.json'
import { fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'

interface Links {
  ios: string;
  android: string;
}

interface State {
  data?: Links;
  notFound: boolean;
}

class MobileLinkSharing extends React.Component<ComponentProps, State> {
  state: State = {
    data: undefined,
    notFound: false,
  }

  componentDidMount () {
    const { congress } = this.props

    if (mobileStoreLinks.hasOwnProperty(congress.Slug)) {
      this.setState({
        data: mobileStoreLinks[congress.Slug]
      })
    } else {
      this.setState({
        notFound: true
      })
    }
  }

  render() {
    const { notFound, data } = this.state

    if (notFound) {
      return (
        <Content>
          {this.renderNotFound()}
        </Content>
      )
    }

    if (data) {
      if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
        window.location.href = data.android
      } else if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
        window.location.href = data.ios
      } else {
        window.location.href = data.android
      }
    }

    return this.renderLoading()
  }

  renderNotFound () {
    return (
      <NotFoundContainer>
        <NotFoundWrapper>
          <LottieAnimation animation={animation} width="200px"/>
          <NotFoundText><Trans>No existen enlaces aún</Trans></NotFoundText>
        </NotFoundWrapper>
      </NotFoundContainer>
    )
  }

  renderLoading () {
      return (
        <LoadingContainer>
          <LoadingWrapper>
            <LottieAnimation animation={loadingAnimation}/>
          </LoadingWrapper>
        </LoadingContainer>
      )
  }
}

const LoadingContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const NotFoundContainer = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const NotFoundWrapper = styled.div`
  max-width: 400px;
  width: 100%;
`
const NotFoundText = styled.h1`
  font-weight: 400;
  color: #666;
  text-align: center;  
 `

const LoadingWrapper = styled.div`
  max-width: 500px;
`


export default withCongress(MobileLinkSharing)